import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import WaitForEventNodePreview from "../../features/sequence/node_previews/WaitForEventNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import { compactSearchableStrings } from "./SearchableInteractionValues";

export interface IWaitForEvent extends Interaction {
  eventName: string;
}

export const waitForEventInteraction = (): InteractionFactoryEntity => {
  const view = <></>;

  const create = (getKeys: (amount: number) => string[]): IWaitForEvent => {
    return {
      id: GetNewGuid(),
      name: "Wait for Event",
      type: InteractionType.WaitForEvent,
      eventName: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IWaitForEvent => {
    return interaction as IWaitForEvent;
  };
  
  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ): IWaitForEvent => {
    return {
      ...(interaction as IWaitForEvent),
      id: GetNewGuid(),
    };
  };
  
  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const converted = interaction as IWaitForEvent;
    return getMatchingResults(
      compactSearchableStrings(interaction.name, converted.eventName),
      takeName,
      interaction,
      "Wait for Event"
    );
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    return [];
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <WaitForEventNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: "Wait for Event",
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
